<template>

    <el-form-item
        :rules="{ required: isFieldRequired, validator: validateField, trigger: 'change' }"
        :prop="fieldProp(field)">

        <span slot="label">
            {{ field.label }}
            <span v-if="!_.isEmpty(field.content)" class="fin-relative fin-z-50 fin-ml-1"
                :class="isFrontend ? 'fin-hidden' : 'fin-hidden 2xl:fin-inline-flex'">
                <el-popover
                    placement="top-start"
                    :title="field.label"
                    width="200"
                    trigger="hover"
                    :content="field.content"
                    :disabled="_.isEmpty(field.content)"
                    popper-class="app-form-field-popover"
                    >
                    <i slot="reference" class="fas fa-circle-info fin-ml-2 fin-text-warning"></i>
                </el-popover>
            </span>
        </span>

        <div v-if="!_.isEmpty(field.content)" class="content fin-flex fin-w-full"
            :class="isFrontend ? '' : '2xl:fin-hidden'">
            {{ field.content }}
        </div>

        <div class="fin-grid fin-gap-5 fin-w-full fin-h-full" :class="blockColumnsClass">
            <div
                @click="selectOption(option)"
                v-for="(option, optionKey) in field.options.choices"
                :key="optionKey"
                class="select-block-item fin-w-full"
                :class="{
                    selected: _.isArray(selectValue) ? selectValue.includes(option.value) : selectValue == option.value
                }">

                <div class="block-item-wrapper fin-flex fin-items-center fin-justify-center">
                    <div class="block-item-inner">
                        <div class="fin-relative fin-flex fin-items-center fin-justify-center fin-flex-col fin-w-full">
                            <div class="fin-text-center fin-mx-auto fin-relative">
                                <i class="fin-text-lg 2xl:fin-text-2xl icon" :class="option.icon"></i>
                            </div>
                            <div class="fin-text-center fin-text-xs sm:fin-text-sm xl:fin-text-base fin-leading-4 fin-font-thin label fin-relative fin-px-5">
                                {{ option.label }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-form-item>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"

export default {
    name: "SelectBlocks",

    mixins: [formMixin],

    props: {
        field: {
            required: true,
            type: [Object, Array],
        },
        fieldKey: {
            required: true,
            type: Number,
        },
        path: {
            required: true,
            type: [String, Number],
        },
        value: {
            required: false,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },

    data() {
        return {
            selectValue: null,
            gridHeight: '100px'
        }
    },

    computed: {
        isFieldRequired() {
            return this.field.isRequired
        },
        blockColumnsClass() {
            switch(this.field.blockColumns) {
                case 1:
                    return [
                        'fin-grid-cols-1'
                    ]
                    break
                case 2:
                    return [
                        'fin-grid-cols-1',
                        'xs:fin-grid-cols-2',
                    ]
                    break
                case 3:
                    return [
                        'fin-grid-cols-1',
                        'xs:fin-grid-cols-3',
                    ]
                    break
                case 4:
                    return [
                        'fin-grid-cols-1',
                        'xs:fin-grid-cols-3',
                        '2xl:fin-grid-cols-4'
                    ]
                    break
                case 5:
                    return [
                        'fin-grid-cols-1',
                        'xs:fin-grid-cols-3',
                        'lg:fin-grid-cols-4',
                        '2xl:fin-grid-cols-5'
                    ]
                    break
                case 6:
                    return [
                        'fin-grid-cols-1',
                        'xs:fin-grid-cols-3',
                        'md:fin-grid-cols-4',
                        'lg:fin-grid-cols-5',
                        '2xl:fin-grid-cols-6'
                    ]
                    break
            }
        }
    },

    mounted() {

        this.$store.dispatch(`${this.formStore}/form/setPagePaths`, this.path)

        if (_.isEmpty(this.selectValue)) {
            if (this.field.options.multiSelect) {
                this.selectValue = []
            } else {
                this.selectValue = ""
            }
        }
    },

    methods: {
        validateField(rule, value, callback) {
            if (!this.selectValue && this.isFieldRequired) {
                callback(new Error(`${this.field.label} is Required`))
            } else {
                callback()
            }
        },
        selectOption(option) {
            if (this.field.options.multiSelect && _.isArray(this.selectValue)) {
                if (this.isOptionSelected(option)) {
                    let fieldIndex = this.selectValue.findIndex((fieldValue) => fieldValue == option.value)
                    Vue.delete(this.selectValue, fieldIndex)
                }
            }
            if (_.isArray(this.selectValue)) {
                this.selectValue.push(option.value)
            } else {
                this.selectValue = option.value
            }
        },
        isOptionSelected(option) {
            return this.selectValue.includes(option.value) ? true : false
        },
    },

    watch: {
        selectValue: {
            handler(selectValue) {
                let path = String(this.path).split(".")
                this.setPathData(path, selectValue)
                this.checkRules(this.field, this.path)

                if (this.field.field_mapping == 'application_type_id') {
                    _.set(this.formData.application, 'loan_type_id', selectValue)
                }

                if (this.field.field_mapping == 'loan_type_id') {
                    _.set(this.formData.application, 'application_type_id', selectValue)
                }
            },
        },
        value: {
            handler(value) {
                this.selectValue = !_.isNull(value) && typeof value != "undefined" ? String(value) : null
            },
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped>
    .select-block-item {

        &:hover {
            @media screen and (min-width: 1200px) {
                .block-item-wrapper {
                    .icon, .label {
                        @apply fin-transition fin-duration-500 #{!important}
                    }

                    .label {
                        @apply fin-text-primary-light #{!important}
                    }

                    .icon {
                        @apply fin-text-primary-light #{!important}
                    }
                }

                @apply fin-border-primary-light fin-shadow-lg fin-border-2 #{!important}
            }

            @apply fin-bg-transparent
        }

        &.selected :deep {

            .block-item-wrapper {
                .icon, .label {
                    @apply fin-transition fin-duration-500 #{!important}
                }

                .label {
                    @apply fin-text-primary-light #{!important}
                }

                .icon {
                    @apply fin-text-primary-light #{!important}
                }
            }

            @apply fin-border-primary-light fin-shadow-lg fin-border-2 #{!important}
        }

        .block-item-wrapper {

            &:before {
                content: '';
                display: block;
                width: 100%;
                padding-top: 100%; /*trick here*/
            }

            .block-item-inner {

                .icon {
                    @apply fin-text-slate-400
                }

                .label {
                    @apply fin-text-slate-600
                }

                .icon, .label {
                    @apply fin-transition fin-duration-500 #{!important}
                }

                @apply fin-flex fin-absolute fin-w-full fin-h-full fin-top-0 fin-right-0 fin-bottom-0 fin-left-0  #{!important}
            }

            @apply fin-relative fin-w-full fin-cursor-pointer #{!important}
        }

        @apply fin-relative fin-text-center fin-w-full fin-h-full fin-flex fin-items-center fin-flex-col fin-border-2 fin-border-stroke-light fin-rounded-xl fin-bg-white fin-transition fin-duration-500 active:hover:fin-bg-primary/20 fin-m-0 fin-p-0  #{!important}
    }
</style>
